export default __webpack_public_path__ + "static/media/0x3c205c8b3e02421da82064646788c82f7bd753b9.3039b2c6.webp";